/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespDealerDetails_item = {
    readonly dealerDetailsDisplayInfo?: {
        readonly ctas: {
            readonly showMakeOffer: boolean | null;
        } | null;
    } | null;
    readonly seller: {
        readonly isRewardsTier2: boolean | null;
        readonly liveStorefrontProfile: {
            readonly aboutUsUnbranded: string | null;
        } | null;
        readonly serviceId?: string | null;
        readonly " $fragmentRefs": FragmentRefs<"PdpSharedDealerDetailsBio_seller" | "PdpSharedDealerDetailsHeader_seller" | "PdpSharedDealerDistinction_seller" | "PdpSharedDealerInfo_seller">;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedCallDealerCta_item" | "ContactDealerInlineForm_item" | "PdpSharedSellerTabsVariant_item" | "PdpRespSimilarItemTileCarousel_item">;
    readonly " $refType": "PdpRespDealerDetails_item";
};
export type PdpRespDealerDetails_item$data = PdpRespDealerDetails_item;
export type PdpRespDealerDetails_item$key = {
    readonly " $data"?: PdpRespDealerDetails_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespDealerDetails_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespDealerDetails_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchPdp",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "seller",
      "storageKey": null,
      "args": null,
      "concreteType": "Seller",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": "isRewardsTier2",
          "name": "isAnchorListMember",
          "args": [
            {
              "kind": "Literal",
              "name": "listName",
              "value": "SELLER_REWARDS_2"
            }
          ],
          "storageKey": "isAnchorListMember(listName:\"SELLER_REWARDS_2\")"
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "liveStorefrontProfile",
          "storageKey": null,
          "args": null,
          "concreteType": "StorefrontProfile",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "aboutUsUnbranded",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "FragmentSpread",
          "name": "PdpSharedDealerDetailsBio_seller",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "PdpSharedDealerDetailsHeader_seller",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "PdpSharedDealerDistinction_seller",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "PdpSharedDealerInfo_seller",
          "args": null
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchPdp",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": "dealerDetailsDisplayInfo",
          "name": "displayInfo",
          "storageKey": null,
          "args": null,
          "concreteType": "ItemDisplayInfo",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "ctas",
              "storageKey": null,
              "args": null,
              "concreteType": "CTADisplay",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "showMakeOffer",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "seller",
          "storageKey": null,
          "args": null,
          "concreteType": "Seller",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "serviceId",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "FragmentSpread",
          "name": "PdpSharedCallDealerCta_item",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "ContactDealerInlineForm_item",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "PdpSharedSellerTabsVariant_item",
          "args": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemTileCarousel_item",
      "args": null
    }
  ]
};
(node as any).hash = 'bf28b687583d41c6dd1f67a47c3f6d76';
export default node;
